<div class="tabela-reunioes">
    <app-card-content [border]="false" headingLevel="h1" [icon]="'pi pi-table'" [title]="'Acompanhamento'" [subtitle]="'Reuniões de comissões e situação das atas'">
        <div card-header class="tabela-reunioes-acoes">
            @if (reuniaoSelecionada()) {
                <app-send-whatsapp #sendWhatsapp [text]="gerarMensagemWhatsappReuniao(reuniaoSelecionada())" [abrirDialog]="true" style="display: none"></app-send-whatsapp>
            }

            <p-button
                icon="pi pi-filter"
                [outlined]="true"
                [pTooltip]="filtrosVisiveis() ? 'Ocultar filtros' : 'Mostrar filtros'"
                tooltipPosition="bottom"
                [ariaLabel]="filtrosVisiveis() ? 'Ocultar filtros' : 'Mostrar filtros'"
                (click)="alternarFiltros.emit()"
                [style]="{ height: '2.2rem', width: '2.2rem', padding: '0' }"
            ></p-button>

            <!-- A legenda ensina os pictogramas a quem chega hoje; para quem já os conhece ela é
                 altura gasta antes da primeira linha (171px medidos). Daí o par de botões: este, ao
                 lado do de filtros, e o "×" dentro do próprio quadro — quem quer fechá-la está
                 olhando para ela, e obrigar a subir até o cabeçalho seria o caminho mais longo.

                 O estado vai no `ariaLabel`, que alterna, e não em `aria-expanded`: o `p-button`
                 encaminha só os inputs que conhece, e um `[attr.]` aqui pousa no host — nunca no
                 <button> que o leitor de tela anuncia. É também o que o botão de filtros faz. -->
            <p-button
                icon="pi pi-info-circle"
                [outlined]="true"
                [pTooltip]="legendaVisivel() ? 'Ocultar legenda' : 'Mostrar legenda'"
                tooltipPosition="bottom"
                [ariaLabel]="legendaVisivel() ? 'Ocultar legenda' : 'Mostrar legenda'"
                (click)="alternarLegenda()"
                [style]="{ height: '2.2rem', width: '2.2rem', padding: '0' }"
            ></p-button>

            <p-button
                icon="pi pi-objects-column"
                [outlined]="true"
                pTooltip="Colunas visíveis"
                tooltipPosition="bottom"
                ariaLabel="Colunas visíveis"
                (click)="op.toggle($event)"
                [style]="{ height: '2.2rem', width: '2.2rem', padding: '0' }"
            ></p-button>
            <p-popover #op [appendTo]="'body'">
                <ng-template #content>
                    <div class="flex flex-col gap-2 p-2 min-w-[200px] max-w-[280px]">
                        <div class="flex items-center justify-between pb-2 border-b border-surface-200 dark:border-surface-700">
                            <span class="font-semibold text-sm">Colunas Visíveis</span>
                            <button class="text-xs text-primary hover:underline cursor-pointer bg-transparent border-none p-0" (click)="toggleTodasColunas()">
                                {{ todasSelecionadas() ? 'Desmarcar Todos' : 'Marcar Todos' }}
                            </button>
                        </div>
                        <div class="flex flex-col gap-1 max-h-[250px] overflow-y-auto pr-1">
                            @for (opcao of opcoesColunas; track opcao.value) {
                                <label class="flex items-center gap-2 p-1.5 hover:bg-surface-50 dark:hover:bg-surface-800 rounded cursor-pointer select-none">
                                    <input type="checkbox" [checked]="colunasSelecionadas.includes(opcao.value)" (change)="toggleColuna(opcao.value)" class="rounded border-surface-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer" />
                                    <span class="text-sm text-surface-700 dark:text-surface-300">{{ opcao.label }}</span>
                                </label>
                            }
                        </div>
                    </div>
                </ng-template>
            </p-popover>

            <app-botao-acoes label="Opções" [iconPos]="EInconPos.LEFT" [items]="itensOpcoesMenu()" [iconColumns]="3"></app-botao-acoes>
        </div>

        <div class="grid-indicadores">
            <app-kpi-comissoes
                icone="pi pi-calendar-clock"
                [tom]="ETomKpi.INFO"
                [valor]="valorAgendadas(dashboardSummary()?.totalAgendadas)"
                rotulo="Reuniões agendadas"
                [legenda]="legendaAgendadas(dashboardSummary()?.totalAgendadas)"
            />

            <app-kpi-comissoes
                icone="pi pi-calendar"
                [tom]="ETomKpi.SUCESSO"
                [valor]="valorDataReuniao(dashboardSummary()?.dataProximaReuniao)"
                rotulo="Próxima reunião"
                [legenda]="legendaDataReuniao(dashboardSummary()?.dataProximaReuniao, dashboardSummary()?.codigoProximaReuniao, 'Não há reuniões futuras')"
            />

            <app-kpi-comissoes
                icone="pi pi-clock"
                [tom]="ETomKpi.ATENCAO"
                [valor]="valorDataReuniao(dashboardSummary()?.dataUltimaReuniao)"
                rotulo="Última reunião"
                [legenda]="legendaDataReuniao(dashboardSummary()?.dataUltimaReuniao, dashboardSummary()?.codigoUltimaReuniao, 'Nenhuma reunião registrada')"
            />
        </div>

        <!-- Quadro de legenda antes da tabela: ensina os pictogramas antes de o olho
             encontrá-los — mesmos ícones, mesmos tons que as células usam. -->
        @if (legendaVisivel()) {
            <div id="acomp-legenda" class="acomp-legenda" aria-label="Legenda dos indicadores de situação e participação">
                @for (bloco of blocosLegenda; track bloco.titulo) {
                    <div class="acomp-legenda-bloco">
                        <span class="acomp-rotulo">{{ bloco.titulo }}</span>
                        @for (item of bloco.itens; track item.nome) {
                            <span class="acomp-legenda-item">
                                <i [ngClass]="[item.icone, 'acomp-pip--' + item.tom]" aria-hidden="true"></i>
                                <span>{{ item.nome }}</span>
                            </span>
                        }
                        @if (bloco.nota) {
                            <span class="acomp-legenda-nota">{{ bloco.nota }}</span>
                        }
                    </div>
                }

                <p-button icon="pi pi-times" [text]="true" size="small" pTooltip="Ocultar legenda" tooltipPosition="left" ariaLabel="Ocultar legenda" styleClass="acomp-legenda-fechar" (onClick)="alternarLegenda()"></p-button>
            </div>
        }

        <app-custom-table
            [data]="dataMapped"
            [metadata]="metadataTabela"
            [first]="first()"
            [rows]="rows()"
            [totalRecords]="totalRegistros() ?? 0"
            [rowsPerPageOptions]="opcoesLinhasPorPagina"
            [loading]="carregando()"
            [rowClickable]="true"
            [initialViewMode]="'table'"
            [cardColumns]="2"
            [useCustomCard]="true"
            [minWidth]="'966px'"
            (onPageChange)="onPaginaAlterada($event)"
            (onRowClick)="handleRowClick($event)"
        >
            <!-- Cada coluna empilha as linhas do próprio assunto: a de cima identifica, as de baixo
                 detalham. O nome do dado acompanha o valor — visível ("Término 16:00"), num span
                 só-de-leitor + tooltip (protocolo, cadastro) ou na legenda (pips) — e é isso que
                 permite empilhar a linha em blocos no telefone sem o cabeçalho — ver o .scss. -->
            <!-- Os blocos de assunto estão declarados uma vez só, no fim deste arquivo, e são
                 instanciados aqui (uma coluna da tabela) e no cartão (um bloco empilhado). Assim as
                 duas visualizações não podem divergir: mudar o desenho de um assunto muda nos dois. -->
            <!-- A única coluna que a API declarativa não alcança, marcada com `celulaCustomizada`:
                 informações são dois grupos de sentidos diferentes — estados e marcas — separados
                 por filete, em duas linhas, e é esse agrupamento que torna a célula legível. As
                 demais saem do metadata: `sub` (identificação, criação, comissão, data e horário) e
                 o tipo `perfil` (assistente). -->
            <ng-template pTemplate="cell" let-rowData="rowData" let-column="column">
                @switch (column.key) {
                    @case ('status') {
                        <ng-container *ngTemplateOutlet="blocoInformacoes; context: { $implicit: rowData }"></ng-container>
                    }
                }
            </ng-template>

            <!-- ═══ Os blocos de assunto ═══════════════════════════════════════════
                 Cada um é o desenho de UM assunto da reunião. A tabela instancia um por
                 coluna; o cartão instancia os seis empilhados. Fonte única: o desenho de
                 um assunto não pode divergir entre as duas visualizações. -->

            <!-- Sem rótulo visível: o selo diz "protocolo" pela forma. O nome do dado segue
                 no tooltip e num span só-de-leitor. -->
            <ng-template #blocoIdentificacao let-rowData>
                <span class="acomp-linha acomp-linha--forte acomp-maquina">#{{ rowData.codigo }}</span>
                @if (rowData.protocolo && rowData.protocolo !== '-') {
                    <span class="acomp-linha">
                        <span class="acomp-chip acomp-chip--protocolo acomp-maquina" pTooltip="Protocolo" tooltipPosition="top"><span class="sr-only">Protocolo </span>{{ rowData.protocolo }}</span>
                    </span>
                }
            </ng-template>

            <!-- Criação e Reunião em compartilham o desenho: dia em cima, hora embaixo, menor. -->
            <ng-template #blocoCriacao let-rowData>
                <span class="acomp-linha acomp-linha--forte acomp-maquina">{{ diaDe(rowData.dataHoraCadastro) }}</span>
                @if (horaDe(rowData.dataHoraCadastro)) {
                    <span class="acomp-linha acomp-maquina acomp-horario">{{ horaDe(rowData.dataHoraCadastro) }}</span>
                }
            </ng-template>

            <!-- O código anda junto do nome ("118 - Câmara…"): é como a comissão é citada nas
                 outras telas. O selo do modo abre a linha do local: modo e lugar se leem
                 juntos. Sem modalidade informada, só o local. -->
            <ng-template #blocoComissao let-rowData>
                <span class="acomp-linha acomp-linha--titulo">
                    <span class="acomp-titulo-nome" [title]="tituloComissao(rowData)">{{ tituloComissao(rowData) }}</span>
                </span>
                <span class="acomp-linha">
                    @if (exibeModalidade(rowData)) {
                        <span class="acomp-chip" [ngClass]="'acomp-chip--' + (rowData.modalidade.severity || 'secondary')" pTooltip="Modalidade" tooltipPosition="top">{{ rowData.modalidade.value }}</span>
                    }
                    {{ rowData.local.value }}
                </span>
            </ng-template>

            <!-- Avatar e nome no mesmo desenho do cadastro de usuários, lado a lado.
                 Sem assistente, a ausência é dita por extenso, em meia-tinta. -->
            <ng-template #blocoAssistente let-rowData>
                @if (iniciaisAssistente(rowData.assistente)) {
                    <span class="acomp-linha acomp-assistente">
                        @if (fotoAssistente(rowData); as foto) {
                            <img [src]="foto" alt="" class="acomp-foto shrink-0" aria-hidden="true" />
                        } @else {
                            <p-avatar
                                [label]="iniciaisAssistente(rowData.assistente)"
                                shape="circle"
                                [style]="{ width: '3.75rem', height: '3.75rem', 'font-size': '1.2rem', 'min-width': '3.75rem' }"
                                class="font-semibold bg-primary/15 text-primary shrink-0"
                                aria-hidden="true"
                            />
                        }
                        <div class="flex flex-col gap-0.5 min-w-0">
                            <span class="acomp-assistente-nome font-medium text-sm">{{ rowData.assistente }}</span>
                        </div>
                    </span>
                } @else {
                    <span class="acomp-linha acomp-vazio">Não Informado</span>
                }
            </ng-template>

            <!-- O dia identifica; a faixa de horário detalha, um corpo abaixo. -->
            <ng-template #blocoReuniaoEm let-rowData>
                <span class="acomp-linha acomp-linha--forte acomp-maquina">{{ diaDe(rowData.dataInicio) }}</span>
                @if (faixaHorario(rowData)) {
                    <span class="acomp-linha acomp-maquina acomp-horario">{{ faixaHorario(rowData) }}</span>
                }
            </ng-template>

            <!-- Situação e participação em pictogramas: o estado se lê pela forma, a cor
                 reforça, e a legenda acima da tabela dá o nome. Cada pip carrega o texto por
                 extenso no tooltip e no `aria-label` — nada depende só do desenho. -->
            <ng-template #blocoInformacoes let-rowData>
                <span class="acomp-linha acomp-situacao">
                    <i
                        class="acomp-pip acomp-pip-reuniao"
                        [ngClass]="[rowData.status.icon || 'pi pi-info-circle', 'acomp-pip--' + (rowData.status.severity || 'secondary')]"
                        role="img"
                        [attr.aria-label]="'Situação da reunião: ' + rowData.status.value"
                        [pTooltip]="'Reunião: ' + rowData.status.value"
                        tooltipPosition="top"
                    ></i>
                    <i
                        class="acomp-pip"
                        [ngClass]="[rowData.statusAta.icon || 'pi pi-file', 'acomp-pip--' + (rowData.statusAta.severity || 'secondary')]"
                        role="img"
                        [attr.aria-label]="'Ata: ' + rowData.statusAta.value"
                        [pTooltip]="'Ata: ' + rowData.statusAta.value"
                        tooltipPosition="top"
                    ></i>
                    @if (rowData.importante.value === 'Sim') {
                        <i class="pi pi-flag-fill acomp-pip acomp-marca" role="img" pTooltip="Ata marcada como importante" tooltipPosition="top" aria-label="Ata marcada como importante"></i>
                    }
                    <span class="acomp-filete" aria-hidden="true"></span>
                    @if (rowData.visivelPortal.value === 'Sim') {
                        <i class="pi pi-globe acomp-pip acomp-pip--tinta" role="img" pTooltip="Visível no portal" tooltipPosition="top" aria-label="Visível no portal: sim"></i>
                    } @else {
                        <i class="pi pi-globe acomp-pip acomp-pip--apagado" role="img" pTooltip="Não visível no portal" tooltipPosition="top" aria-label="Visível no portal: não"></i>
                    }
                    @if (rowData.atividades.value === 'Sim') {
                        <i class="pi pi-list-check acomp-pip acomp-pip--tinta" role="img" pTooltip="Reunião com atividades" tooltipPosition="top" aria-label="Atividades: sim"></i>
                    } @else {
                        <i class="pi pi-list-check acomp-pip acomp-pip--apagado" role="img" pTooltip="Reunião sem atividades" tooltipPosition="top" aria-label="Atividades: não"></i>
                    }
                </span>
                <span class="acomp-linha acomp-participacao">
                    <span class="acomp-parcela" [pTooltip]="rotuloParticipacao(rowData)" tooltipPosition="top">
                        <i class="pi pi-users" aria-hidden="true"></i>
                        <span class="acomp-maquina" aria-hidden="true">{{ razaoParticipacao(rowData) }}</span>
                        <span class="sr-only">{{ rotuloParticipacao(rowData) }}</span>
                    </span>
                    <span aria-hidden="true">·</span>
                    <span class="acomp-parcela" [pTooltip]="rowData.atosConcessao + ' atos de concessão'" tooltipPosition="top">
                        <i class="pi pi-verified" aria-hidden="true"></i>
                        <span class="acomp-maquina" aria-hidden="true">{{ rowData.atosConcessao }}</span>
                        <span class="sr-only">{{ rowData.atosConcessao }} atos de concessão</span>
                    </span>
                </span>
            </ng-template>

            <ng-template pTemplate="card" let-rowData let-selected="selected" let-isExpanded="isExpanded">
                <!-- O mesmo corpo veste duas cascas: cartão com moldura na grade de cards e
                     painel liso (card-content sem borda) quando é a linha expandida da tabela —
                     lá a moldura já é a própria linha. -->
                <ng-template #corpoReuniao>
                    <!-- O cartão é a linha da tabela empilhada: os mesmos seis blocos de assunto, um
                         sob o outro, separados por filete pontilhado — o desenho que a tabela já usa
                         no telefone. Sem cabeçalho nem rodapé próprios: tudo o que eles diziam já
                         está nos blocos (situação nos pips, código e protocolo na identificação,
                         data de cadastro na criação, confirmações na participação), e repetir seria
                         dizer duas vezes. -->
                    <!-- O nome de cada assunto vai num span só-de-leitor AQUI, e não dentro do bloco:
                         na tabela o `<th>` já nomeia a coluna e repetir seria dizer duas vezes; no
                         cartão não há cabeçalho, e sem isto "23/06/2026" e "11/07/2026" chegariam ao
                         leitor de tela como duas datas sem assunto. -->
                    <div class="reuniao-card-blocos">
                        <div class="reuniao-card-bloco"><span class="sr-only">Identificação</span><ng-container *ngTemplateOutlet="blocoIdentificacao; context: { $implicit: rowData }"></ng-container></div>
                        <div class="reuniao-card-bloco"><span class="sr-only">Criada em</span><ng-container *ngTemplateOutlet="blocoCriacao; context: { $implicit: rowData }"></ng-container></div>
                        <div class="reuniao-card-bloco"><span class="sr-only">Comissão e local</span><ng-container *ngTemplateOutlet="blocoComissao; context: { $implicit: rowData }"></ng-container></div>
                        <div class="reuniao-card-bloco"><span class="sr-only">Assistente</span><ng-container *ngTemplateOutlet="blocoAssistente; context: { $implicit: rowData }"></ng-container></div>
                        <div class="reuniao-card-bloco"><span class="sr-only">Reunião em</span><ng-container *ngTemplateOutlet="blocoReuniaoEm; context: { $implicit: rowData }"></ng-container></div>
                        <div class="reuniao-card-bloco reuniao-card-bloco--informacoes"><span class="sr-only">Informações</span><ng-container *ngTemplateOutlet="blocoInformacoes; context: { $implicit: rowData }"></ng-container></div>
                    </div>
                </ng-template>

                @if (isExpanded) {
                    <!-- Expandido: a célula desdobrada — cada dado com ícone, rótulo e valor por
                         extenso, numa grade de colunas iguais. Os ícones de estado mantêm o tom
                         dos pips da tabela; os demais ficam em tinta neutra. O cabeçalho do card
                         identifica a reunião de relance: código, dia e situação. -->
                    <app-card-content [icon]="'pi pi-users'" [title]="tituloComissao(rowData)" [subtitle]="subtituloExpandido(rowData)">
                        <div card-header class="exp-header">
                            <span class="acomp-chip acomp-maquina">#{{ rowData.codigo }}</span>
                            <span class="acomp-chip" [ngClass]="'acomp-chip--' + (rowData.status.severity || 'secondary')">
                                <i [ngClass]="rowData.status.icon || 'pi pi-info-circle'" aria-hidden="true"></i>
                                {{ rowData.status.value }}
                            </span>
                            <!-- O recolher saiu daqui: agora é do `app-custom-table`, na própria
                                 célula expandida, valendo para toda tabela com card próprio. -->
                        </div>

                        <div class="reuniao-expandido">
                            <app-detalhe-grid>
                                <app-detalhe-item icone="pi pi-hashtag" rotulo="Reunião"
                                    ><span class="acomp-maquina">#{{ rowData.codigo }}</span></app-detalhe-item
                                >

                                @if (rowData.protocolo && rowData.protocolo !== '-') {
                                    <app-detalhe-item icone="pi pi-bookmark" rotulo="Protocolo">
                                        <span class="acomp-chip acomp-chip--protocolo acomp-maquina">{{ rowData.protocolo }}</span>
                                    </app-detalhe-item>
                                }

                                <app-detalhe-item icone="pi pi-calendar-plus" rotulo="Criada em"
                                    ><span class="acomp-maquina">{{ rowData.dataHoraCadastro }}</span></app-detalhe-item
                                >

                                <app-detalhe-item icone="pi pi-calendar-clock" rotulo="Data e Horário">
                                    <span class="acomp-maquina">
                                        {{ diaDe(rowData.dataInicio) }}
                                        @if (faixaHorario(rowData)) {
                                            <span aria-hidden="true">·</span> {{ faixaHorario(rowData) }}
                                        }
                                    </span>
                                </app-detalhe-item>

                                <app-detalhe-item icone="pi pi-map-marker" rotulo="Local">{{ rowData.local.value }}</app-detalhe-item>

                                <app-detalhe-item icone="pi pi-user" rotulo="Assistente">
                                    @if (iniciaisAssistente(rowData.assistente)) {
                                        <span class="exp-assistente">
                                            @if (fotoAssistente(rowData); as foto) {
                                                <img [src]="foto" alt="" class="acomp-foto acomp-foto--miuda" aria-hidden="true" />
                                            }
                                            {{ rowData.assistente }}
                                        </span>
                                    } @else {
                                        <span class="acomp-vazio">Não Informado</span>
                                    }
                                </app-detalhe-item>

                                <app-detalhe-item [icone]="rowData.status.icon || 'pi pi-info-circle'" rotulo="Situação" [tom]="rowData.status.severity || 'secondary'">{{ rowData.status.value }}</app-detalhe-item>

                                <app-detalhe-item [icone]="rowData.statusAta.icon || 'pi pi-file'" rotulo="Ata" [tom]="rowData.statusAta.severity || 'secondary'">
                                    {{ rowData.statusAta.value }}
                                    @if (rowData.importante.value === 'Sim') {
                                        <i class="pi pi-flag-fill acomp-marca" role="img" pTooltip="Ata marcada como importante" tooltipPosition="top" aria-label="Ata marcada como importante"></i>
                                    }
                                </app-detalhe-item>

                                <app-detalhe-item icone="pi pi-globe" rotulo="Visível no Portal" [tom]="rowData.visivelPortal.value === 'Sim' ? 'tinta' : 'apagado'">{{ rowData.visivelPortal.value }}</app-detalhe-item>

                                <app-detalhe-item icone="pi pi-list-check" rotulo="Atividades" [tom]="rowData.atividades.value === 'Sim' ? 'tinta' : 'apagado'">{{ rowData.atividades.value }}</app-detalhe-item>

                                <app-detalhe-item icone="pi pi-users" rotulo="Participação">{{ rotuloParticipacao(rowData) }}</app-detalhe-item>

                                <app-detalhe-item icone="pi pi-verified" rotulo="Atos de Concessão"
                                    ><span class="acomp-maquina">{{ rowData.atosConcessao }}</span></app-detalhe-item
                                >
                            </app-detalhe-grid>
                        </div>
                    </app-card-content>
                } @else {
                    <app-card-container [selected]="selected || isRowSelected(rowData)" [hoverEfect]="true" class="reuniao-card-item cursor-pointer block h-full">
                        <ng-container *ngTemplateOutlet="corpoReuniao"></ng-container>
                    </app-card-container>
                }
            </ng-template>
        </app-custom-table>
    </app-card-content>
</div>
